import React, { useState, useContext } from 'react';
import * as firebase from  "firebase/app";
import "firebase/auth";
import firebaseConfig from './firebase.config';
import { UserContext } from '../../App';
import { useHistory, useLocation } from 'react-router-dom';
import "./Login.css"
firebase.initializeApp(firebaseConfig); 

function Login () {
  const [newUser,setNewUser]= useState(false)
  const [user, setUser] = useState({
    isSignedIn: false,
    name: "",
    email: "",
    photoURL: "",
    error:"",
    success:false,
  })
  const [loggedInUser,setLoggedInUser] =useContext(UserContext)
 const history= useHistory()
 const location =useLocation();
 let { from } = location.state || { from: { pathname: "/" } };

  //   const googleProvider = new firebase.auth.GoogleAuthProvider();
  // const fbProvider=new firebase.auth.FacebookAuthProvider();
  // const handleSignIn = () => {
  //   firebase.auth().signInWithPopup(googleProvider)
  //     .then(res => {
  //       const { displayName, email, photoURL } = res.user;

  //       const signedInUser = {
  //         isSignedIn: true,
  //         name: displayName,
  //         email: email,
  //         photo: photoURL,
  //       }
  //       setUser(signedInUser); 

  //     })
  //     .catch(err => {

  //     })

  // }
  // const handleFbLogin=()=>{
  //   firebase.auth().signInWithPopup(fbProvider).then(function(result) {
  //     // This gives you a Facebook Access Token. You can use it to access the Facebook API.
  //     var token = result.credential.accessToken;
  //     // The signed-in user info.
  //     var user = result.user;
  //     // ...
  //   }).catch(function(error) {
  //     // Handle Errors here.
  //     var errorCode = error.code;
  //     var errorMessage = error.message;
  //     // The email of the user's account used.
  //     var email = error.email;
  //     // The firebase.auth.AuthCredential type that was used.
  //     var credential = error.credential;
  //     // ...
  //   });
  // }
  // const handleSignOut = () => {
  //   firebase.auth().signOut()
  //     .then(res => {
  //       const signedOutUser = {
  //         isSignedOut: false,
  //         name: "", 
  //         email: "",
  //         photoURL: "",
  //       }
  //       setUser(signedOutUser);
  //       console.log(res);
  //     })
  //     .catch(err => { 
  //       console.log(err);
  //     })
  // }
  const handleBlur = (e) => {
    // console.log(e.target.name, e.target.value);
    let isFromValid;
    if (e.target.name === "email") {
      isFromValid = /\S+@\S+\.\S+/.test(e.target.value)

    }
    if (e.target.name === "name") {
      isFromValid = e.target.value.length < 15
    }
    if (e.target.name === "password") {
       const passwordValidation = e.target.value.length > 6
       const passwordHasNumber = /\d{1}/.test(e.target.value)
       isFromValid = passwordValidation && passwordHasNumber;
    }
    if (isFromValid) {
      const userInfo = { ...user }
      userInfo[e.target.name] = e.target.value;
      setUser(userInfo)

    }
  }

  const handelSubmit = (e) => {
    // console.log( user.email, user.password);
      if(newUser && user.email && user.password){
      firebase.auth().createUserWithEmailAndPassword(user.email, user.password)
      .then(res =>{
        const newUserInfo={ ...user}
          newUserInfo.error='';
          newUserInfo.success=true;
          setUser(newUserInfo)
          updateUserName(user.name);
      })
      .catch(error => {
             const newUserInfo={ ...user}
             newUserInfo.error=error.message;
             newUserInfo.success=false;
               setUser(newUserInfo)
           
           });

      }
     if(!newUser && user.email && user.password){
       firebase.auth().signInWithEmailAndPassword(user.email,user.password)
      .then(res =>{
        const newUserInfo={ ...user}
          newUserInfo.error='';
          newUserInfo.success=true;
          setUser(newUserInfo)
          setLoggedInUser(newUserInfo);
          history.replace(from)
        console.log("sign in user info" , res.user);
      })
      .catch(error => {
             const newUserInfo={ ...user}
             newUserInfo.error=error.message;
             newUserInfo.success=false;
               setUser(newUserInfo)
           
           });
     
     }
      e.preventDefault();
    }
    const updateUserName= name =>{
     const user = firebase.auth().currentUser;

       user.updateProfile({
      displayName:name
    
    }).then(function(){
       console.log("user name update successfully");
     }).catch(function (error) {
       console.log(error);
     })
    }
  return (
    <div style={{textAlign:"center"}} className="login-aria"> 
      
      {/* {   
        user.isSignedIn ? <button onClick={handleSignOut}>sign out </button> :
          <button onClick={handleSignIn} className="btn btn-success">sign in </button>
      } 
         <br/>
         <br/>
        <button onClick={handleFbLogin} className="btn btn-primary">usin facebook sign up</button>
     {   user.isSignedIn && <div>
          <p>welcome to {user.name} </p>
          <p>email{user.email}</p>
          <img style={{ width: "50%" }} src={user.photo} alt="" />
        </div>
     } */}
 
      
       <h1>our form autentication</h1><br/>
       <div className="from-aria">
       <input type="checkbox" onChange={()=>setNewUser(!newUser)} name="newUser" id=""/>
       <label htmlFor="newUser" className="text-white">New User Sign Up</label>
      <form onSubmit={handelSubmit} className="main-from">
       {newUser && <input type="text"  name="name" onBlur={handleBlur} placeholder="Write your name" required  />}<br /><br/>
        <input onBlur={handleBlur} type="text" name="email" placeholder="write your email" required /><br /> <br/>
        <input onBlur={handleBlur} type="password" name="password" placeholder="write your password" required /><br /> <br/>
           <button className="btn btn-info" value="Submit">Submit</button>
      </form>
       </div>
        <h3 style={{color:"red"}}>{user.error}</h3>
        {user.success && <h3 style={{color:"green"}}> User {newUser ? "created" :"logged In" }  successfully</h3>}
    </div>
  );
}

export default Login;